module.exports = __webpack_public_path__ + "img/ads@3x.b173bb7b.png";